<div class="notes-container" [style.margin-top]="data?.marginTop">
  <div class="notes-card" [class.tco-notes-box]="data?.widgetId === 'repower-notes-override'">
    <ng-container *ngFor="let note of notes; trackBy: trackById">
      <div class="note-item">
        <h3 class="note-label">{{ note.label }}</h3>
        <div class="note-text" [innerHTML]="note.text"></div>
      </div>
    </ng-container>
    <div class="notes-footer" *ngIf="footer?.displayFooter">
      <span class="footer-text">{{ footer?.text }}</span>
    </div>
  </div>
</div>
